
import Alert from 'react-s-alert';

export const GeneralAlert =(type, message) => {
    switch (type.toLowerCase()){
        case 'success':
            Alert.success(message, {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 5000
            });
            break;
        case 'error':
            Alert.error(message, {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 5000
            });
            break;
        case 'warning':
            Alert.warning(message, {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 5000
            });
            break;
        default:
            Alert.info(message, {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 5000
            });
    }
}